<template>
  <div
    v-show="$parent.participant"
    class="position-relative participantsContainer">
    <div class="fs14 d-none d-md-block py-3"><b>Participants</b>
      <b-badge>{{ participants.length }}</b-badge>
    </div>
    <div class="mobileHeader shadow">
      <span class="m-auto fs14"><b>Participants</b></span>
      <close-icon @click="toggleTab()"/>
    </div>
    <perfect-scrollbar>

      <ul class="list-unstyled">
        <li
          v-for="(person, index) in participants"
          :key="index"
          class="d-flex align-items-center  flex-row justify-content-between">
          <div class="d-flex">
            <name-dot
              :first-name="person.firstName"
              :last-name="person.lastName"/>
            <img
              v-if="person.image"
              :src="person.image"
              class="img d-flex">
            <div class="d-flex flex-column name">
              {{ person.firstName }} {{ person.lastName }}
              <small 
                v-if="person.isWebrtc"
                class="d-flex">Joined From Web</small>
            </div>
          </div>
          <microphone-off-icon
            v-if="person.isMuted"
            class="muted"/>
        </li>
      </ul>
    </perfect-scrollbar>
  </div>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar'
import MicrophoneOffIcon from "icons/MicrophoneOff"
import CloseIcon from "icons/Close"
import {ref} from "@vue/composition-api"
import NameDot from "./NameDot"



export default {
  name: 'Participants',
  components: {
    NameDot,
    PerfectScrollbar,
    MicrophoneOffIcon,
    CloseIcon
  },
  setup(props, context) {
    const participants = ref([])
    let ids = []
    function toggleTab() {
      context.parent.$parent.expanded = !context.parent.$parent.expanded
      context.parent.participant = !context.parent.participant
    }

    function processPresense(message){
      const regex = /\[([^\]]+)]/g
      if(message.meetingID !== -1){
        if(!ids.includes(message.user.id) && message.user.firstName !== ''){
          message.user.isMuted = true
          message.user.videoOff = true
          message.extra.match(regex).forEach(function(match){
            let keyPairs = match.slice(1,-1).split('=')
            message.user[keyPairs[0]] = !!keyPairs[1]  // extra info for the user
          })
          participants.value.push(message.user)
          context.parent.$parent.numberOfPeople = participants.value.length
          ids.push(message.user.id)
        }

      } else {
        if(ids.includes(message.user.id)){
          let user = participants.value.find(user => user.id === message.user.id)
          if(user) {
            const index = participants.value.indexOf(user)
            participants.value.splice(index, 1)
            ids.splice(ids.indexOf(message.user.id), 1)
            context.parent.$parent.numberOfPeople = participants.value.length
          }
        }
      }
    }

    function processParticipant(message){
      let user = participants.value.find(user => user.id === message.userID)
      if(user) {
        const index = participants.value.indexOf(user)
        if(!user.isSelf) {  // Only Control others with websocket messages
          user.isMuted = !message.isAudioOn
          user.videoOff = !message.isVideoOn
        }
        user.wsParticipant = message
        participants.value.splice(index, 1, user)  // this is literally a vue caveat
        if (message.video.length > 0) {
          for (let i = 0; i < message.video.length; i++) {
            let stream = context.parent.$parent.remoteVideoStreams.find(stream => stream.ssrc === message.video[i].ssrcAlt)
            if (stream) {
              const streamIndex = context.parent.$parent.remoteVideoStreams.indexOf(stream)
              stream.user = user
              context.parent.$parent.remoteVideoStreams.splice(streamIndex, 1, stream)
            }
          }
        }
        if (message.userID === context.parent.$parent.metaUserInfo.id){
          user.isSelf = true
          context.parent.$parent.localVideoStreams.forEach(element => element.user = user)
        }
      }
    }

    return {
      processPresense,
      toggleTab,
      participants,
      processParticipant
    }


  }
}
</script>
<style scoped>
li{
  height: 48px;
}
.participantsContainer{
 margin: 24px;
}
li .img{
  border-radius: 100%;
  width: 32px;
  margin-right: 12px;
}
.name{
  font-weight: 600;
  font-size: 14px;
}
.name small{
  font-weight: normal;
  font-size: 11px;
  color: #BBBBBB;
}
.muted{
  color: #f15f55;
}
.badge{
font-weight: 700;
  height: 17px;
  line-height: 9px;
  margin-left: 11px;
  width: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/Participants.vue